/** @jsx jsx */
import { Button, Modal, Spacer, TextGroupMedium } from "@cd2/components"
import { css, jsx } from "@emotion/core"
import { useEffect, useState } from "react"
import { Checkbox } from "../Components/2023FormFields/Checkbox"
import { brandColors } from "../Components/EOSThemeProvider"
import { AutoSendOrderAcknowledgementCheckbox } from "../stories/quoteOrders/QuotesOrdersForm"
import { useConfirmation } from "./useConfirmation"
import { useSettings } from "../utils/useSettings"
import { IRecord } from "../types/schema"
import { P } from "@cd2/text"

export function useDeliverItemsConfirmOrderAcknowledgement() {
  const [a, b] = useConfirmation<
    { contact?: IRecord<"contacts", "email">; deliveryNoteEmail: string },
    "onExport" | "onPick" | "onDelivery" | undefined
  >(({ onResolve, data }) => {
    const { allowDisableAutoOrderRequestEmail, defaultAutoOrderRequestEmailDisabled } =
      useSettings()
    const canSelectOption = !!data.contact || !!data.deliveryNoteEmail
    const [state, setState] = useState<"onExport" | "onPick" | "onDelivery" | undefined>(
      canSelectOption && !defaultAutoOrderRequestEmailDisabled ? "onPick" : undefined,
    )
    useEffect(() => {
      setState(canSelectOption && !defaultAutoOrderRequestEmailDisabled ? "onPick" : undefined)
    }, [canSelectOption && !defaultAutoOrderRequestEmailDisabled])
    return (
      <Modal
        render={() => (
          <div>
            <TextGroupMedium heading="Order acknowledgement email for back order" />
            <Spacer />
            {!(data?.contact?.email || data?.deliveryNoteEmail) && (
              <P color="red">
                There is no valid contact or delivery note email to send the order acknowledgement
                to.
              </P>
            )}
            <Checkbox
              label="Auto send order acknowledgement"
              onChange={value => {
                if (allowDisableAutoOrderRequestEmail) {
                  if (!value) {
                    setState(undefined)
                  } else {
                    setState("onPick")
                  }
                }
              }}
              value={!allowDisableAutoOrderRequestEmail || !!state}
              disabled={!allowDisableAutoOrderRequestEmail}
              description={`This will email the order acknowledgement automatically at the chosen point to ${
                data?.contact?.email || data?.deliveryNoteEmail
              }.`}
            />
            {!!state && (
              <div
                css={css`
                  border: 1px solid ${brandColors.midGrey};
                  padding: 4px;
                `}
              >
                <AutoSendOrderAcknowledgementCheckbox
                  onChange={value => setState(value)}
                  disabled={!(data?.contact?.email || data?.deliveryNoteEmail)}
                  value={state}
                />
              </div>
            )}
            <Spacer />
            <Button
              children="Submit"
              onClick={() => onResolve(state)}
              disabled={state && !(data?.contact?.email || data?.deliveryNoteEmail)}
            />
          </div>
        )}
        isOpen
      />
    )
  })

  return { confirmOrderAcknowledgementEmailNode: a, handleConfirmOrderAcknowledgementEmail: b }
}
